var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InputNumber',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=$$v},expression:"fieldValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }